import { speak } from "@/utils/tts"

type SpeechPlayback = Awaited<ReturnType<typeof speak>>

const MAX_NOTIFICATION_SPEECH_QUEUE_SIZE = 5
const NOTIFICATION_SPEECH_MAX_PLAYBACK_MS = 90000
let currentSpeechPlayback: SpeechPlayback | null = null
let finishCurrentPlayback: (() => void) | null = null
let speechQueueRunning = false
const speechQueue: string[] = []

function finishCurrentSpeech() {
  currentSpeechPlayback = null
}

async function playNotificationSpeech(text: string) {
  await new Promise<void>((resolve) => {
    let settled = false
    let playback: SpeechPlayback | null = null
    let timeoutId: number | undefined

    const finish = () => {
      if (settled) return
      settled = true
      if (timeoutId !== undefined) window.clearTimeout(timeoutId)
      finishCurrentPlayback = null
      finishCurrentSpeech()
      resolve()
    }

    finishCurrentPlayback = finish
    timeoutId = window.setTimeout(() => {
      playback?.stopSpeak()
      finish()
    }, NOTIFICATION_SPEECH_MAX_PLAYBACK_MS)

    speak({
      text,
      provider: "LocalTTS",
      onFinish: finish,
    }).then((result) => {
      playback = result
      if (settled) {
        result.stopSpeak()
        return
      }
      currentSpeechPlayback = result
    }).catch((error) => {
      console.warn("[tts] notification speech failed", error)
      finish()
    })
  })
}

async function processSpeechQueue() {
  if (speechQueueRunning) return
  speechQueueRunning = true
  try {
    while (speechQueue.length > 0) {
      const text = speechQueue.shift()
      if (text) await playNotificationSpeech(text)
    }
  }
  finally {
    speechQueueRunning = false
  }
}

export function enqueueNotificationSpeech(text: string) {
  const normalized = text.trim()
  if (!normalized) return
  speechQueue.push(normalized)
  while (speechQueue.length > MAX_NOTIFICATION_SPEECH_QUEUE_SIZE) speechQueue.shift()
  processSpeechQueue().catch((error) => {
    console.warn("[tts] notification speech queue failed", error)
  })
}

export function clearNotificationSpeechQueue() {
  speechQueue.length = 0
  currentSpeechPlayback?.stopSpeak()
  finishCurrentPlayback?.()
  finishCurrentPlayback = null
  currentSpeechPlayback = null
}
